import api from 'api';
import storage from "@/cflow/storageService";

class AgendaProtetica {

    listar(from, to) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/agenda-protetica?from='+from+'&to=' + to + '&token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    detalhes(id) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/agenda-protetica/' + id + '?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }


    salvar(id, form) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            if(id) id = '/' + id;
            api.post('/agenda-protetica' + id + '?token='+user.token, form).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    listarProcedimentos(idLab, idPro) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/agenda-protetica/procedimentos/' + idLab + '/' + idPro + '?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    listarRelatorio(from, to, skip, protetico = 0, getProtList = 0) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/agenda-protetica/relatorio/servicos?from='+from+'&to=' + to + '&skip=' + skip + '&idProt=' + protetico + '&getProtList=' + getProtList + '&token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    imprimirRelatorio(from, to, skip, protetico = 0) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/agenda-protetica/relatorio/servicos?imprimir=1&from='+from+'&to=' + to + '&skip=' + skip + '&idProt=' + protetico + '&token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    listarServicosParaPagar(idxs) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.get('/agenda-protetica/relatorio/pagamentos/' + idxs + '?token='+user.token).then((result) => {
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    upload(files) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.defaults.headers['Content-Type'] = 'multipart/form-data'
            var formData = new FormData();
            files.forEach(function(item, key){
                formData.append('file-' + key, item);
            })
            api.post('/upload?token='+user.token, formData).then((result) => {
                api.defaults.headers['Content-Type'] = 'application/json'
                resolve(result.data);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    salvarPagamento(idxs, form) {
        return new Promise((resolve, reject) => {
            const user = storage.get('user');
            api.post('/agenda-protetica/relatorio/pagamentos/' + idxs + '?token='+user.token, form).then((result) => {
                if(result.status == 200) resolve(result.data);
                if(result.status !== 200) reject(result);
            }).catch((error) => {
                reject(error);
            });
        });
    }


}
export default new AgendaProtetica();